import React from "react";

const Button = ({
  label,
  type = "button",
  disabled = false,
  onClick,
  variant = "primary",
}) => {
  const baseStyle =
    "flex items-center gap-1 lg:px-6 lg:py-3 transition duration-200 rounded-2xl text-sm leading-5 tracking-[2%]";

  const variants = {
    primary: "bg-[#CD2224] text-white hover:bg-black",
    secondary: "bg-[#F5E0DF] hover:bg-black hover:text-white text-[#CD2224]",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyle} ${variants[variant]} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      {label}
    </button>
  );
};

export default Button;
